import React, {Component} from 'react'
import Sidebar from '../../layout/Sidebar';
import Header from '../../layout/Header';
import { Link } from "react-router-dom";
import {CategoryManagement, Filter, Pencil, Delete } from '../../../SvgIcon';
import moment from 'moment-timezone';
import '../../../assets/css/adManagement.css';
import { DownOutlined } from '@ant-design/icons';
import {Menu, Dropdown, Checkbox, DatePicker, TimePicker, Select} from 'antd';
import {_Api} from "../../../services/Api";
import Url from "../../../services/BaseUrl";
import {notify} from "../../../components/Toaster";
import dateFormat from "dateformat";

import { Modal, Button, Space, Empty } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import {getTimeFormate} from "../../../utils/DateZone"

const { confirm } = Modal;



const { Option } = Select;

class RoleList extends Component{
    constructor(props) {
        super(props);
        this.state = {
            page:1,
            limit:50,
            download:0,
            searchKey:'',
            sortField:'categoryTitle',
            sortType:1,
            parentCategoryId:'',
            categoryType:"",
            level:1,
            list:[],
            totalCount:0,
            isLoader:false,
            placeofWorkId:""
        }
        this.getCategory=this.getCategory.bind(this);
        this.getDate=this.getDate.bind(this);
        this.onChanged=this.onChanged.bind(this);
     
    }

    componentDidMount(){
        this.getCategory();
        this.getPlaceofWork();
    }

    getDate(date){
        if(date&&date!=''){
            return getTimeFormate(date)
        }
    }

    getCategory(){
        let params = {
            page: this.state.page,
            limit: this.state.limit,
            searchKey: this.state.searchKey,
            sortField:this.state.sortField,
            sortType:this.state.sortType,
            placeOfWorkId:this.state.placeofWorkId
        }
        _Api(Url.ROLE_LIST.method, Url.ROLE_LIST.url, params )
            .then(resp => {
                console.log('responseData', resp.responseData);
                this.setState({
                    list:resp.responseData.result.data,
                    totalCount:resp.responseData.totalCount,
                    isLoader:false
                })
            }).catch(err => {
            this.setState({ isLoader: false })
            if (err.error)
                notify("err", err.error.responseMessage)
            else if (err)
                // notify("err", err.message)
            this.setState({ isLoader: false })
        })
    }

    onChanged(e) {
        //console.log("e", e);
        let self=this;
        let keyName=e.target.name;
        let KeyValue=e.target.value;
        this.setState({[e.target.name]: e.target.value},function () {
            if(keyName==='searchKey'){
                if(KeyValue.length>=3){
                    self.getCategory();
                }
                else if(KeyValue.length == 0)
                self.getCategory();
            }
        });
    }

     onChange=(date, dateString) =>{
        console.log(date, dateString);
    };

    changeStatus = (e, id,status) => {
        console.log("change status")
        let req = {
            roleId: id,
            status: status?"0":"1",
        }
        _Api(Url.ROLE_STATUS_CHANGE.method, Url.ROLE_STATUS_CHANGE.url, req)
            .then(resp => {
                this.getCategory()
            }).catch(err => {
            if (err.error)
                notify("err", err.error.responseMessage)
            // else if (err)
                // notify("err", err.message)
        })
    }

    deleteCategory = (categoryId)=>{
        let req = {
            roleId: categoryId,
        }
        _Api(Url.ROLE_DELTED.method, Url.ROLE_DELTED.url, req)
            .then(resp => {
                this.getCategory()
            }).catch(err => {
            if (err.error)
                notify("err", err.error.responseMessage)
            // else if (err)
                // notify("err", err.message)
        })
    }

    selectOnChange = (type, e) => {
        let self=this;
        this.setState({
            [type]: e,
        },function () {
            self.getCategory();
        })
    }

    // delete modal
    showDeleteConfirm = (id) => {
        confirm({
            title: 'Are you sure you want to delete this?',
            icon: <ExclamationCircleOutlined />,
            // content: 'Some descriptions',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            centered: true,
            onOk: () => {
             this.deleteCategory(id)
            },
            onCancel: () => {
                this.handleCancel()
            },
        });
    }

      //Cancel modal
      handleCancel = () => {
        // console.log('delete', resp.responseData.message)
          this.setState({ visible: false });
    };

    getPlaceofWork = () => {
        _Api(Url.GET_PLACE_OF_WORK_LIST_placeOfWorkList.method, Url.GET_PLACE_OF_WORK_LIST_placeOfWorkList.url)
            .then(resp => {
                console.log('responseData', resp.responseData);
                var sectorDropDown =[]
                let sectorList = resp.responseData.result.map((item) => {
                    sectorDropDown.push(
                        <Option key={item._id}>{item.name}</Option>
                    )
                })
                this.setState({sectorDropDown,isLoader: false});

            }).catch(err => {
            this.setState({ isLoader: false })
            if (err.error)
                notify("err", err.error.responseMessage)
            this.setState({ isLoader: false })
        })
    }


    render(){
        console.log("this.state",this.state)
        return (
            <>
                <div className="dash_body_container">
                    {/*<Header />*/}
                    {/*<Sidebar />*/}
                    <div className="body_container categorymanagement">
                        <div className="header-text d-flex flex-wrap mb-4 mt-3">

                            <div className="d-flex flex-grow-1 align-items-center">
                                <p className="header-icon"><CategoryManagement /></p>
                                <h4>Role Management</h4>
                            </div>

                            <div className="rounded-textbox-form filter-select pr-2">

                                <Select placeholder="Select" name="userType" onChange={(e) => this.selectOnChange("placeofWorkId", e)}>
                                    <Option>All Place of Work</Option>
                                    {this.state.sectorDropDown}
                                </Select>
                            </div>

                            <Link to="/role/add" className="btn btn-red">Add Role</Link>

                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered rounded-table ">
                                <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        <th>Role Name </th>
                                        <th>Create Date</th>
                                        <th>Status</th>
                                        <th >Action</th> 
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.list.length>0?
                                    this.state.list.map((data,index)=>(
                                    <tr key={data._id}>
                                        <td><span className="circle-serial">{((this.state.page-1)*this.state.limit)+index+1}</span></td>
                                        <td>
                                            {/*<Link to={"/sector/"+data._id}>*/}
                                                {data.name}
                                            {/*</Link>*/}
                                        </td>

                                        <td>{this.getDate(data.created)}</td>
                                        <td>
                                        <p className="toggle-parent ">
                                                <label className="switch">
                                                    <input type="checkbox"
                                                           checked={data.status === 1 ? true : false}
                                                           onChange={(e) => this.changeStatus(e, data._id,data.status)}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </p>
                                        </td>
                                        <td className="action_group">
                                            <Link to={"/role/edit/"+data._id}><p className="circle-serial" ><Pencil /></p></Link>

                                          <p className="circle-serial" onClick={()=> this.showDeleteConfirm(data._id)}>  <Delete /></p>
                                        </td>
                                    </tr>
                                        )):""}

                                </tbody>
                            </table>
                        
                        <div>
                            {!this.state.isLoader && this.state.list?.length == 0 &&
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                        </div>

                        </div>
                        </div>
                </div>
             </>
        );
    }
}

export default RoleList;
